//headers

const tlHeaders1 = gsap.timeline({
    scrollTrigger: {
      trigger: "main .shopify-section:first-child",
    start: "-20%",
    end: "100%",
      ease: "fast"
    }
});




tlHeaders1.fromTo(
    ".shopify-section:first-child .image-with-text__media",
  {  opacity: 0,  translateY: "50"  },
  {  opacity: 1, translateY: "0" , duration: "0.7" } 

);
 

tlHeaders1.fromTo(
    ".shopify-section:first-child .image-with-text__heading",
  {  opacity: 0, translateY: "50"  },
  {  opacity: 1, translateY: "0" , duration: "0.7" } 

);

const tlHeaders2 = gsap.timeline({
    scrollTrigger: {
      trigger: "main .shopify-section:nth-child(2)",
    start: "-20%",
    end: "100%",
      ease: "slow"
    }
});
tlHeaders2.fromTo(
    ".shopify-section:nth-child(2) .image-with-text__media",
  {  opacity: 0,  translateY: "50"  },
  {  opacity: 1, translateY: "0" , duration: "0.7" } 

);
 



tlHeaders2.fromTo(
    ".shopify-section:nth-child(2) .image-with-text__heading",
  {  opacity: 0, translateY: "50"  },
  {  opacity: 1, translateY: "0" , duration: "0.7" } 

);



const tlHeaders3 = gsap.timeline({
    scrollTrigger: {
      trigger: "main .shopify-section:nth-child(3)",
    start: "-50%",
    end: "100%",
      ease: "slow"
    }
});

tlHeaders3.fromTo(
    ".shopify-section:nth-child(3) .image-with-text__media",
  {  opacity: 0,  translateY: "50"  },
  {  opacity: 1, translateY: "0" , duration: "0.7" } 

);
tlHeaders3.fromTo(
    "main .shopify-section:nth-child(3) .image-with-text__heading",
  {  opacity: 0, translateY: "50"  },
  {  opacity: 1, translateY: "0" , duration: "0.7" } 

); 

tlHeaders3.fromTo(
    "main .shopify-section:nth-child(3) .image-with-text__text",
  {  opacity: 0, translateY: "50"  },
  {  opacity: 1, translateY: "0" , duration: "0.7" } 

);



tlHeaders3.fromTo(
    "main .shopify-section:nth-child(4) h2",
  {  opacity: 0,  translateY: "50"  },
  {  opacity: 1, translateY: "0" , duration: "0.7" } 

);
 
/*
const tlHeaders4 = gsap.timeline({
    scrollTrigger: {
      trigger: "main .shopify-section:nth-child(4)",
    start: "-300%",
    end: "100%",
      ease: "slow"
    }
});

tlHeaders4.fromTo(
    ".shopify-section:nth-child(4) h2",
  {  opacity: 0,  translateY: "50"  },
  {  opacity: 1, translateY: "0" , duration: "0.7" } 

);
 */
